export const options = [
  {
    id: 'existing_charge',
    title: 'Vincular a uma cobrança ou CNPJ existente',
    description: 'Esta unidade será vinculada a uma cobrança já existente.'
  },
  {
    id: 'same_charge',
    title: 'Usar o mesmo CNPJ/CPF, mas em cobranças separadas',
    description: 'Os dados do pagador serão os mesmos, porém esta unidade terá sua cobrança separada.'
  },
  {
    id: 'another_charge',
    title: 'Usar um novo CNPJ/CPF, com cobranças separadas',
    description: 'Será utilizado um novo cadastro de cobrança para esta unidade.'
  }
];